import React from 'react'
import clsx from 'clsx'
import PropTypes from 'prop-types'

import CancelIcon from '@material-ui/icons/Cancel'

import { emphasize, makeStyles, Chip } from '@material-ui/core'

const useStyles = makeStyles(theme => ({
  chip: {
    margin: theme.spacing(0.5, 0.25)
  },
  chipFocused: {
    backgroundColor: emphasize(theme.palette.type === 'light' ? theme.palette.grey[300] : theme.palette.grey[700], 0.08)
  }
}))

const MultiValue = props => {
  const classes = useStyles()

  return (
    <Chip
      tabIndex={-1}
      label={props.children}
      className={clsx(classes.chip, {
        [classes.chipFocused]: props.isFocused
      })}
      onDelete={props.removeProps.onClick}
      deleteIcon={<CancelIcon {...props.removeProps} />}
    />
  )
}

MultiValue.propTypes = {
  children: PropTypes.node,
  isFocused: PropTypes.bool,
  removeProps: PropTypes.object.isRequired,
  selectProps: PropTypes.object.isRequired
}

export default MultiValue
